    <div class="container">
        <a [href]="dataSource?.Section?.Data?.Url" target="_blank">
            <img class="hidden md:block mx-auto w-full" [src]="dataSource?.Section?.Data?.PictureUrl" height="110" width="328" loading="lazy" alt="تصویر بنر تکی ایران هتل آنلاین">
        </a>
    </div>
